<template>
  <div :class="`spinner ${active === false ? '' : 'active'}`" :style="`width: ${size}; height: ${size}`">
    <div class="rotating-circle">
      <div class="circle-left">
        <div :style="`border: ${borderWidth} solid transparent; border-left-color: ${color}; border-top-color: ${color};`" />
      </div>
      <div class="circle-right">
        <div :style="`border: ${borderWidth} solid transparent; border-right-color: ${color}; border-top-color: ${color};`" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'spinner',
  props: {
    color: {
      type: String,
      default: '#C64DFF'
    },
    active: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: '120px'
    },
    borderWidth: {
      type: String,
      default: '6px'
    }
  }
}
</script>

<style lang="scss" scoped>
.spinner {
  display: none;

  &.active {
    display: block;
  }

  .rotating-circle {
    display: inline-flex;
    width: inherit;
    height: inherit;
    animation: rotate 1s infinite linear;

    & > div {
      position: relative;
      width: 50%;
      height: inherit;
      overflow: hidden;

      & > div {
        position: absolute;
        border-radius: 50%;
        border-color: transparent;
        width: 200%;
        left: 0;
        right: 0;
        height: inherit;
      }

      &.circle-left > div {
        transform: rotate(60deg);
        animation: rotation-left 1.5s infinite ease-in-out;
      }

      &.circle-right > div {
        transform: rotate(-60deg);
        left: -100%;

        animation: rotation-right 1.5s infinite ease-in-out;
      }
    }
  }

  @keyframes rotate {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  @keyframes rotation-left {
    0% { transform: rotate(100deg); }
    50% { transform: rotate(45deg); }
    100% { transform: rotate(100deg); }
  }

  @keyframes rotation-right {
    0% { transform: rotate(-100deg); }
    50% { transform: rotate(-45deg); }
    100% { transform: rotate(-100deg); }
  }
}
</style>
